import React from 'react';
import { Card, CardContent, Grid, Typography, Chip } from '@mui/material';
import { QuizWithQuestions } from '../../../types/quiz';

interface QuizMetadataProps {
  quiz: QuizWithQuestions;
}

/**
 * Displays quiz metadata in a card layout
 * Shows description, total quiz time estimate, and publication status
 */
const QuizMetadata: React.FC<QuizMetadataProps> = ({ quiz }) => {
  // Calculate total estimated time from all question time limits
  const totalTimeSeconds = quiz.questions?.reduce((sum, q) => sum + (q.timeLimitSeconds || 0), 0) || 0;
  const totalTimeMinutes = Math.ceil(totalTimeSeconds / 60);

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Description
            </Typography>
            <Typography variant="body1">
              {quiz.description || 'No description provided'}
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="subtitle2" color="text.secondary">
              Total Time Estimate
            </Typography>
            <Typography variant="body1">
              ~{totalTimeMinutes} minute{totalTimeMinutes !== 1 ? 's' : ''}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Based on question time limits
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="subtitle2" color="text.secondary">
              Status
            </Typography>
            <Chip
              label={quiz.isPublished ? 'Published' : 'Draft'}
              color={quiz.isPublished ? 'success' : 'default'}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuizMetadata;
